// import { setSellerNetworkError, setBuyerPoorNetwork } from '../reducers/callSlice'
import NotificationsService from './notifications/index'
import { CallNotifications } from '../constants/callNotifications'
import { NetworkQualityLevel } from '../constants/networkQualityLevels'
class CallService {
  constructor() {
    this.notificationService = null
    this.networkStatusHistory = []

    if (!CallService.instance) {
      this._map = new Map()
      this.eventHandlers = {}
      CallService.instance = this
    }
    return CallService.instance
  }

  on(event, handler) {
    if (!this.eventHandlers[event]) {
      this.eventHandlers[event] = []
    }
    this.eventHandlers[event].push(handler)
  }

  off(event, handler) {
    const index = this.eventHandlers[event]?.indexOf(handler)
    if (index >= 0) {
      this.eventHandlers[event].splice(index, 1)
    }
  }

  dispatchEvent(event, params) {
    this.eventHandlers[event]?.forEach((handler) => handler(...params))
  }

  callActions() {
    return this._map.get('callActions')
  }

  setLikeMessageReceivedHandler(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onLikeMessageReceived: handleMeesage,
    })
  }

  setExternalReactionReceived(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onExternalReactionReceived: handleMeesage,
    })
  }

  setQuickAddReceived(handleMessage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onQuickAddReceived: handleMessage,
    })
  }

  setFinishEventCountdownMessageHandler(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onFinishEventCountMessage: handleMeesage,
    })
  }

  setStartEventCountdownMessageHandler(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onStartEventCountMessage: handleMeesage,
    })
  }

  setChatCooldownMessageHandler(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onChatCooldownMessage: handleMeesage,
    })
  }

  setEventFinishedMessageHandler(handleMessage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onEventFinishedMessage: handleMessage,
    })
  }

  setDisplayPopUpMessageHandler(handleMeesage) {
    const actions = this.callActions()
    this._map.set('callActions', {
      ...actions,
      onDisplayPopUpMessage: handleMeesage,
    })
  }

  async joinNotificationsChannel(channelId) {
    try {
      //Notifications service
      this.notificationService = NotificationsService.getInstance(channelId)
      this.notificationService.subscribe((notification) => {
        this.onNotificationReceived(notification)
      })
    } catch (error) {
      console.error(error)
    }
  }

  onNotificationReceived(notification) {
    const { event, payload } = notification
    const payloadParsed = JSON.parse(payload)
    switch (event) {
      case CallNotifications.LIKE:
        this.callActions().onLikeMessageReceived()
        break
      case CallNotifications.SHOW_REACTIONS:
        this.callActions().onExternalReactionReceived(payloadParsed)
        break
      case CallNotifications.FINISH_EVENT_COUNTDOWN:
        this.callActions().onFinishEventCountMessage(payloadParsed)
        break
      case CallNotifications.START_EVENT_COUNTDOWN:
        this.callActions().onStartEventCountMessage(payloadParsed)
        break
      case CallNotifications.SHOW_POPUP:
        this.callActions().onDisplayPopUpMessage(payloadParsed, true)
        break
      case CallNotifications.HIDE_POPUP:
        this.callActions().onDisplayPopUpMessage(
          {
            title: '',
            description: '',
            couponCode: '',
          },
          false,
        )
        break
      case CallNotifications.SHOW_QUICK_ADD:
        this.callActions().onQuickAddReceived(true)
        break
      case CallNotifications.HIDE_QUICK_ADD:
        this.callActions().onQuickAddReceived(false)
        break
      case CallNotifications.SLOW_MODE_CHAT:
        this.callActions().onChatCooldownMessage(payloadParsed)
        break
      case CallNotifications.EVENT_FINISHED:
        this.callActions().onEventFinishedMessage()
        break
      default:
        break
    }
  }

  getMostFrequentNetworkQuality() {
    for (const status of this.networkStatusHistory) {
      if (Object.prototype.hasOwnProperty.call(NetworkQualityLevel, status)) {
        NetworkQualityLevel[status] += 1
      }
    }

    const sortedEntries = Object.entries(NetworkQualityLevel).sort((a, b) => a[1] - b[1])
    return sortedEntries.length > 0 ? sortedEntries[sortedEntries.length - 1][0] : null
  }

  async notifyChannelLikeMessage() {
    const msg = {
      event: CallNotifications.LIKE,
    }
    await this.notificationService.sendMessage(msg)
  }

  async unsubscribeNotifications() {
    await this.notificationService.unsubscribe()
  }
}

export const CallServiceEvents = {
  CLOSE_EVENT: 'CLOSE_EVENT',
  BUYER_JOINED: 'BUYER_JOINED',
  BUYER_LEFT: 'BUYER_LEFT',
  BUYER_PUBLISHED_CAMERA: 'BUYER_PUBLISHED_CAMERA',
  BUYER_UNPUBLISHED_CAMERA: 'BUYER_UNPUBLISHED_CAMERA',
  BUYER_PUBLISHED_MICROPHONE: 'BUYER_PUBLISHED_MICROPHONE',
  BUYER_UNPUBLISHED_MICROPHONE: 'BUYER_UNPUBLISHED_MICROPHONE',
  EXCEPTION: 'exception',
}

const instance = new CallService()

export default instance
